module.exports = __webpack_public_path__ + "static/008-4cdccaa66477964a3e5c5bb97855492f.png";